/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/require-default-props */
import { Button, Group, Space } from '@mantine/core';
import { useModals } from '@mantine/modals';
import { IconCheck, IconPlus, IconShare, IconX } from '@tabler/icons-react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { normalizeResiduePlanPrimaries } from '../../../../../../business/proposals/residue-plan';
import { validarReferenciaServicoCompartilhado } from '../../../../../../business/proposals/validation';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { useProposalGeneralContext } from '../../../../../../contexts/core/proposals/ProposalGeneral.context';
import { ProposalResidueProvider } from '../../../../../../contexts/core/proposals/ProposalResidue.context';
import {
  EntityTypeType,
  ResidueStateOfMatterType,
  UnitOfMeasureType,
} from '../../../../../../models/core/cache.type';
import { Action, ItemToleranceType } from '../../../../../../models/core/core.type';
import {
  ProposalResiduePlanEquipmentType,
  ProposalResiduePlanPackagingType,
  ProposalResiduePlanQuotationEquipmentType,
  ProposalResiduePlanQuotationPackagingType,
  ProposalResiduePlanQuotationType,
  ProposalResiduePlanType,
  ProposalResidueType,
  ProposalType,
} from '../../../../../../models/core/proposals.type';
import { montarRecorrenciaString } from '../../../../../../utils/business.utils';
import { Feature } from '../../../../../../utils/constants.utils';
import ResidueFormAddEdit from './ResidueFormView/ResidueFormAddEdit';
import ResidueFormViewActions from './ResidueFormView/ResidueFormViewActions';
import ResiduePlanSummaryEditor from './ResidueFormView/components/ResiduePlanSummaryEditor';

type ProposalResidueFormViewProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    entityTypeData: EntityTypeType[];
    residueStateOfMatterType: ResidueStateOfMatterType[];
  };
  proposal: ProposalType | null;
  zIndex: number;
};

const ResidueFormView = forwardRef((props: ProposalResidueFormViewProps, ref) => {
  const { proposalGeneralData } = useProposalGeneralContext();
  const modals = useModals();

  const [data, setData] = useState<ProposalResidueType[]>(
    props.proposal?.residuos.map((x) =>
      normalizeResiduePlanPrimaries({
        ...x,
        action: Action.Nothing,
        id: x.idPropostaResiduo?.toString() || '',
      })
    ) || []
  );

  const openResidueEditor = (
    item: ProposalResidueType | null,
    defaultActiveKey?: string,
    initialPlanItem?: ProposalResiduePlanType | null,
    initialQuotationItem?: ProposalResiduePlanQuotationType | null,
    initialPlanTab?: string,
    autoOpenPlanModal?: boolean,
    initialPlanGeneralTab?: string,
    initialPlanGeneralItemId?: string | number | null,
    initialPlanGeneralItemAction?: 'add' | 'open',
    initialQuotationTab?: string,
    initialQuotationChildItemId?: string | number | null,
    initialQuotationChildTab?: string,
    autoOpenQuotationModal?: boolean
  ) => {
    modals.openModal({
      title: `Resíduo - ${item ? 'Editar' : 'Adicionar'}`,
      size: '80%',
      closeOnClickOutside: false,
      children: (
        <ProposalResidueProvider>
          <ResidueFormAddEdit
            referenceData={props.referenceData}
            proposalGeneralData={proposalGeneralData}
            origItem={
              item
                ? props.proposal?.residuos.find((x) => x.idPropostaResiduo === item.idPropostaResiduo) || null
                : null
            }
            item={item}
            idProposta={props.proposal?.idProposta}
            services={proposalGeneralData.servicos}
            callback={confirmActionResult}
            zIndex={props.zIndex + 1}
            defaultActiveKey={defaultActiveKey}
            initialPlanItem={initialPlanItem || null}
            initialQuotationItem={initialQuotationItem || null}
            initialPlanTab={initialPlanTab || 'Geral'}
            autoOpenPlanModal={autoOpenPlanModal || false}
            initialPlanGeneralTab={initialPlanGeneralTab || 'Acondicionamentos'}
            initialPlanGeneralItemId={initialPlanGeneralItemId ?? null}
            initialPlanGeneralItemAction={initialPlanGeneralItemAction || 'open'}
            initialQuotationTab={initialQuotationTab || 'Geral'}
            initialQuotationChildItemId={initialQuotationChildItemId ?? null}
            initialQuotationChildTab={initialQuotationChildTab || 'Cotacao'}
            autoOpenQuotationModal={autoOpenQuotationModal || false}
          />
        </ProposalResidueProvider>
      ),
    });
  };

  const getPlanKey = (plan: ProposalResiduePlanType) =>
    plan.id || plan.idPropostaResiduoPlano?.toString() || plan.idTemporaria || '';

  const matchesResidue = (entry: ProposalResidueType, item: ProposalResidueType | null) => {
    if (!item) {
      return false;
    }

    if (entry.id && item.id && `${entry.id}` === `${item.id}`) {
      return true;
    }

    if (
      entry.idPropostaResiduo &&
      item.idPropostaResiduo &&
      entry.idPropostaResiduo === item.idPropostaResiduo
    ) {
      return true;
    }

    return false;
  };

  const getPrimaryMobilizationPlan = (row: ProposalResidueType) =>
    row.planos.find((x) => x.primario && x.codigoPlanoTipo === 'M') ||
    row.planos.find((x) => x.codigoPlanoTipo === 'M') ||
    null;

  const columns: ColumnsType<any> = [
    {
      title: 'Resíduo',
      key: 'residuo',
      sorter: (a: ProposalResidueType, b: ProposalResidueType) =>
        a.residuoCliente.localeCompare(b.residuoCliente),
      render: (row: ProposalResidueType) => {
        return (
          <ProfileCardLink
            id={row.idResiduo.toString()}
            name={row.residuoCliente}
            nameSize="sm"
            description={`Código IBAMA: ${row.codigoIBAMA || '-'} | Perigoso: ${
              row.residuoClientePerigoso ? 'Sim' : 'Não'
            }`}
            descriptionSize="xs"
            showLink={false}
          />
        );
      },
    },
    {
      title: 'Mínimo Aceitável',
      key: 'minimoAceitavel',
      sorter: (a: ProposalResidueType, b: ProposalResidueType) => {
        const aItem = a.minimoAceitavel
          ? `${a.minimoAceitavel} ${a.minimoAceitavelUnidadeMedida1} / ${a.minimoAceitavelUnidadeMedida2}`
          : '';
        const bItem = a.minimoAceitavel
          ? `${b.minimoAceitavel} ${b.minimoAceitavelUnidadeMedida1} / ${b.minimoAceitavelUnidadeMedida2}`
          : '';
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalResidueType) => {
        if (!row.minimoAceitavel) {
          return '-';
        }
        return (
          <div>{`${row.minimoAceitavel} ${row.minimoAceitavelUnidadeMedida1} / ${row.minimoAceitavelUnidadeMedida2}`}</div>
        );
      },
    },
    {
      title: 'Estimativa',
      key: 'estimativa',
      sorter: (a: ProposalResidueType, b: ProposalResidueType) => {
        const aItem = a.estimativa
          ? `${a.estimativa} ${a.estimativaUnidadeMedida1} / ${a.estimativaUnidadeMedida2}`
          : '';
        const bItem = b.estimativa
          ? `${b.estimativa} ${b.estimativaUnidadeMedida1} / ${b.estimativaUnidadeMedida2}`
          : '';
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalResidueType) => {
        if (!row.estimativa) {
          return '-';
        }
        return (
          <div>{`${row.estimativa} ${row.estimativaUnidadeMedida1} / ${row.estimativaUnidadeMedida2}`}</div>
        );
      },
    },
    {
      title: 'Recorrência',
      key: 'recorrencia',
      render: (row: ProposalResidueType) => {
        const recorrencia = montarRecorrenciaString(row.recorrencia);
        if (!recorrencia) {
          return '-';
        }
        return (
          <div>
            <div>{recorrencia.str1}</div>
            {recorrencia.str2 ? <div>{recorrencia.str2}</div> : <></>}
          </div>
        );
      },
    },
    {
      title: 'Planos',
      key: 'planos',
      sorter: (a: ProposalResidueType, b: ProposalResidueType) => {
        const aValue = a.planos.filter((x) => x.action !== Action.Delete).length;
        const bValue = b.planos.filter((x) => x.action !== Action.Delete).length;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: ProposalResidueType) => {
        let isComplete = false;
        const primaryPlan = row.planos.find((x) => x.primario);
        const primaryMobilizationPlan = getPrimaryMobilizationPlan(row);
        if (primaryPlan) {
          isComplete = primaryPlan.cotacoes.some((x) => x.primario);
        }
        return (
          <Group gap="xs">
            <div>{row.planos.length || '-'}</div>
            <div>{isComplete ? <IconCheck color="green" /> : <IconX color="red" />}</div>
            {primaryMobilizationPlan?.acondicionamentos?.find((x) => x.compartilhado) && (
              <div>
                <IconShare size={16} />
              </div>
            )}
          </Group>
        );
      },
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row: ProposalResidueType) => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        <ResidueFormViewActions item={row} confirmActionResult={confirmActionResult} />
      ),
    },
  ];

  const confirmActionResult = (item: ProposalResidueType | null, action: string, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    let dataItemIndex;
    let dataItem;

    switch (action) {
      case 'excluir':
        dataItemIndex = data.findIndex((x) => matchesResidue(x, item));
        if (dataItemIndex > -1) {
          const nextData = [...data];
          dataItem = nextData[dataItemIndex];
          if (dataItem.idPropostaResiduo) {
            nextData[dataItemIndex] = { ...dataItem, action: Action.Delete };
          } else {
            nextData.splice(dataItemIndex, 1);
          }
          setData(JSON.parse(JSON.stringify(nextData)));
        }
        break;
      case 'editar':
      case 'adicionar':
        openResidueEditor(item);
        break;
      case 'callback':
      case 'callback-all':
        modals.closeAll();
        dataItemIndex = data.findIndex((x) => matchesResidue(x, item));
        {
          const nextData = [...data];
          if (dataItemIndex > -1) {
            dataItem = nextData[dataItemIndex];
            nextData[dataItemIndex] = normalizeResiduePlanPrimaries({ ...dataItem, ...item });
          } else {
            nextData.push(normalizeResiduePlanPrimaries(item!));
          }
          setData(JSON.parse(JSON.stringify(nextData)));
        }
        break;
      case 'primarioPlano':
        dataItemIndex = data.findIndex((x) => matchesResidue(x, item));
        if (dataItemIndex > -1) {
          const nextData = [...data];
          const residue = { ...nextData[dataItemIndex] };
          const targetPlan = item?.planos.find((x) => x.primario) || null;
          if (!targetPlan) {
            break;
          }

          const targetPlanKey = getPlanKey(targetPlan);
          residue.planos = residue.planos.map((plan) => {
            if ((plan.action || Action.Nothing) === Action.Delete) {
              return plan;
            }

            const isTarget = getPlanKey(plan) === targetPlanKey;
            let nextAction = plan.action || Action.Nothing;

            if (isTarget && nextAction === Action.Nothing) {
              nextAction = Action.Modify;
            } else if (!isTarget && plan.primario && nextAction === Action.Nothing) {
              nextAction = Action.Modify;
            }

            return {
              ...plan,
              primario: isTarget,
              action: nextAction,
            };
          });

          nextData[dataItemIndex] = normalizeResiduePlanPrimaries(residue);
          setData(nextData);
        }
        break;
      default:
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    validate(): ProposalResidueType[] {
      data.forEach((x: ProposalResidueType) => {
        // remove unnecessary data and format it
        delete (x as any).residuoData;
        delete (x as any).clienteData;
        delete (x as any).enderecoData;

        // set default actions & custom validations
        x.idResiduo = Number(x.idResiduo);
        x.documento.action = x.documento?.action || Action.Nothing;
        x.recorrencia.action = x.recorrencia?.action || Action.Nothing;
        x.planos.forEach((plano: ProposalResiduePlanType) => {
          plano.action = plano.action || Action.Nothing;

          plano.acondicionamentos.forEach((acondicionamento: ProposalResiduePlanPackagingType) => {
            acondicionamento.idResiduoAcondicionamento = Number(acondicionamento.idResiduoAcondicionamento);
            acondicionamento.action = acondicionamento.action || Action.Nothing;

            if (acondicionamento.compartilhado && acondicionamento.action !== Action.Delete) {
              const refSharedService = proposalGeneralData.servicos.find(
                (xs) =>
                  (acondicionamento.idPropostaServico &&
                    xs.idPropostaServico === acondicionamento.idPropostaServico) ||
                  (acondicionamento.idPropostaServicoTemp && xs.id === acondicionamento.idPropostaServicoTemp)
              );

              if (
                !validarReferenciaServicoCompartilhado(
                  acondicionamento.idResiduoAcondicionamento,
                  x.idEntidadeEndereco,
                  refSharedService
                )
              ) {
                throw Error(
                  `Existe(m) resíduo(s) com acondicionamento(s) compartilhado(s) associado(s) com um serviço inválido: Resíduo (Cliente): ${x.residuoCliente} | Acondicionamento: ${acondicionamento.residuoAcondicionamento}`
                );
              }
            }
          });
          plano.equipamentos.forEach((equipamento: ProposalResiduePlanEquipmentType) => {
            equipamento.idResiduoEquipamento = Number(equipamento.idResiduoEquipamento);
            equipamento.action = equipamento.action || Action.Nothing;
          });
          if (plano.veiculo) {
            plano.veiculo.idResiduoVeiculo = Number(plano.veiculo.idResiduoVeiculo);
            plano.veiculo.action = plano.veiculo.action || Action.Nothing;
          }
          if (plano.tratamento) {
            plano.tratamento.idResiduoTratamento = Number(plano.tratamento.idResiduoTratamento);
            plano.tratamento.action = plano.tratamento.action || Action.Nothing;
          }
          if (plano.destinoFinal) {
            plano.destinoFinal.idResiduoDestinoFinal = Number(plano.destinoFinal.idResiduoDestinoFinal);
            plano.destinoFinal.action = plano.destinoFinal.action || Action.Nothing;
          }

          plano.cotacoes.forEach((cotacao: ProposalResiduePlanQuotationType) => {
            cotacao.action = cotacao.action || Action.Nothing;

            cotacao.acondicionamentos.forEach(
              (acondicionamento: ProposalResiduePlanQuotationPackagingType) => {
                acondicionamento.idFornecedor = Number(acondicionamento.idFornecedor);
                acondicionamento.action = acondicionamento.action || Action.Nothing;

                acondicionamento.tolerancias.forEach((y: ItemToleranceType) => {
                  y.action = y.action || Action.Nothing;
                });

                // sync shared-service quotation with packaging
                const refSharedPackaging = plano.acondicionamentos.find(
                  (xa) =>
                    acondicionamento.action !== Action.Delete &&
                    xa.compartilhado &&
                    ((xa.idPropostaResiduoPlanoAcondicionamento &&
                      xa.idPropostaResiduoPlanoAcondicionamento ===
                        acondicionamento.idPropostaResiduoPlanoAcondicionamento) ||
                      (xa.id && xa.id === acondicionamento.id))
                );

                if (refSharedPackaging) {
                  // service is valid as per the packaging validation logic above
                  const refSharedService = proposalGeneralData.servicos.find(
                    (xs) =>
                      (refSharedPackaging.idPropostaServico &&
                        xs.idPropostaServico === refSharedPackaging.idPropostaServico) ||
                      (refSharedPackaging.idPropostaServicoTemp &&
                        xs.id === refSharedPackaging.idPropostaServicoTemp)
                  );
                  const refSharedServiceQuotation = refSharedService?.cotacoes.find(
                    (xsq) => xsq.primario && xsq.action !== Action.Delete
                  )!;

                  if (
                    refSharedServiceQuotation?.action === Action.Add ||
                    refSharedServiceQuotation?.action === Action.Modify
                  ) {
                    acondicionamento.action = Action.Modify;

                    acondicionamento.idFornecedor = Number(refSharedServiceQuotation.idFornecedor);
                    acondicionamento.idEntidadeResiduoAcondicionamento =
                      refSharedServiceQuotation.idEntidadeResiduoAcondicionamento!;
                    acondicionamento.quantidade = refSharedServiceQuotation.quantidade;
                    acondicionamento.quantidadeIdUnidadeMedida =
                      refSharedServiceQuotation.frequenciaIdUnidadeMedida1;
                    acondicionamento.frequenciaIdUnidadeMedida =
                      refSharedServiceQuotation.frequenciaIdUnidadeMedida2;
                    acondicionamento.preco = 0;
                    acondicionamento.observacao = refSharedServiceQuotation.observacao;
                  }
                }
              }
            );
            cotacao.equipamentos.forEach((equipamento: ProposalResiduePlanQuotationEquipmentType) => {
              equipamento.idFornecedor = Number(equipamento.idFornecedor);
              equipamento.action = equipamento.action || Action.Nothing;

              equipamento.tolerancias.forEach((y: ItemToleranceType) => {
                y.action = y.action || Action.Nothing;
              });
            });
            if (cotacao.veiculo) {
              cotacao.veiculo.idFornecedor = Number(cotacao.veiculo.idFornecedor);
              cotacao.veiculo.action = cotacao.veiculo.action || Action.Nothing;

              cotacao.veiculo.tolerancias.forEach((y: ItemToleranceType) => {
                y.action = y.action || Action.Nothing;
              });
            }
            if (cotacao.tratamento) {
              cotacao.tratamento.idFornecedor = Number(cotacao.tratamento.idFornecedor);
              cotacao.tratamento.action = cotacao.tratamento.action || Action.Nothing;

              cotacao.tratamento.tolerancias.forEach((y: ItemToleranceType) => {
                y.action = y.action || Action.Nothing;
              });
            }
            if (cotacao.destinoFinal) {
              cotacao.destinoFinal.idFornecedor = Number(cotacao.destinoFinal.idFornecedor);
              cotacao.destinoFinal.action = cotacao.destinoFinal.action || Action.Nothing;

              cotacao.destinoFinal.tolerancias.forEach((y: ItemToleranceType) => {
                y.action = y.action || Action.Nothing;
              });
            }
          });
        });
      });
      return data.map((item) => normalizeResiduePlanPrimaries(item));
    },
    clear() {
      setData([]);
    },
  }));

  return (
    <div>
      <Group justify="space-between">
        <PageSection
          size="lg"
          color={Feature.Home.Proposal.color}
          label="Resíduos"
          text="Todos os resíduos a serem gerenciados e requisitados pelo cliente juntamente com seus planos de coleta, tratamento e/ou destinação e cotações."
        />
        <Button
          color="primary"
          leftSection={<IconPlus size={18} />}
          onClick={() => {
            confirmActionResult(null, 'adicionar', true);
          }}
        >
          Adicionar
        </Button>
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        dataSource={data.filter((x) => x.action !== Action.Delete)}
        columns={columns}
        rowKey={(item: ProposalResidueType) => item.id || 0}
        expandable={{
          rowExpandable: () => true,
          // eslint-disable-next-line react/no-unstable-nested-components
          expandedRowRender: (row) => (
            <ResiduePlanSummaryEditor
              data={row}
              isEdit
              referenceData={{
                unitOfMeasures: props.referenceData.unitOfMeasures,
                entityTypeData: props.referenceData.entityTypeData,
              }}
              services={proposalGeneralData.servicos}
              zIndex={props.zIndex + 2}
              onChange={(nextResidue) => {
                const nextData = [...data];
                const residueIndex = nextData.findIndex((x) => matchesResidue(x, row));
                if (residueIndex === -1) {
                  return;
                }

                nextData[residueIndex] = nextResidue;
                setData(nextData);
              }}
            />
          ),
        }}
        pagination={{
          locale: { items_per_page: 'página' },
          pageSizeOptions: [10, 25, 50],

          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
});

export default ResidueFormView;
